import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

export const employeeManagerGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.profileReady();

    if (
        authService.isSuperUser ||
        authService.isDirector ||
        authService.isSupervisor ||
        authService.isManager
    ) {
        return true;
    }

    if (state.url !== '/no-access') {
        router.navigate(['/no-access']);
    }
    return false;
};
